import BansheeToggle from './src/Toggle'

BansheeToggle.install = function (Vue) {
  Vue.component(BansheeToggle.name, BansheeToggle)
}

export default BansheeToggle
